'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  fetchSmsRemind (vacancyId) {
    return Axios.get(`/1.0/vacancies/${vacancyId}/sms-remind-templates`)
      .then(response => parseResponse(response).data)
      .catch(err => {
        throw handleError(err)
      })
  },

  updateSmsRemind ({ vacancyId, templates }) {
    return Axios.put(`/1.0/vacancies/${vacancyId}/sms-remind-templates`, {templates})
      .then(response => parseResponse(response).data[0])
      .catch(err => {
        throw handleError(err)
      })
  },

  renderSmsRemind ({ vacancyId, templates }) {
    return Axios.post(`/1.0/vacancies/${vacancyId}/sms-remind-templates/render`, {templates})
      .then(response => parseResponse(response).data[0])
      .catch(err => {
        throw handleError(err)
      })
  },

  fetchSmsInvite (vacancyId) {
    return Axios.get(`/1.0/vacancies/${vacancyId}/sms-templates`)
      .then(response => parseResponse(response).data)
      .catch(err => {
        throw handleError(err)
      })
  },

  updateSmsInvite ({ vacancyId, templates }) {
    return Axios.put(`/1.0/vacancies/${vacancyId}/sms-templates`, {templates})
      .then(response => parseResponse(response).data[0])
      .catch(err => {
        throw handleError(err)
      })
  },

  renderSmsInvite ({ vacancyId, templates }) {
    return Axios.post(`/1.0/vacancies/${vacancyId}/sms-templates/render`, {templates})
      .then(response => parseResponse(response).data[0])
      .catch(err => {
        throw handleError(err)
      })
  }
}
